// Source: app/scripts/services/crud.js
/*
 * Generic CRUD resource REST service
 */
Auction.factory('crudService', ['$resource', function($resource) {
  return function(type, additionalMethods) {
    var extendedMethods = {
      'import': {
        method: 'POST',
        url: "/data/rest/" + type + "/import"
      },
      create: {
        method: 'GET',
        url: "/data/rest/" + type + "/new"
      },
      paged: {
        method: 'GET',
        url: "/data/rest/" + type + "/paged"
      },
      getActive: {
        method: 'GET',
        url: "/data/rest/" + type + "/active",
        isArray: true
      }
    };
    if (additionalMethods) {
      angular.forEach(additionalMethods, function(v, k) {
        extendedMethods[k] = v;
      });
    }
    return $resource('/data/rest/' + type + '/:id', {}, extendedMethods);
  };
}]);
